import {
  companyCodeColumnDefinition,
  countryTaxTypeDescriptionColumnDefinition,
  adjustmentTypeColumnDefinition,
  descriptionColumnDefinition,
  amountFromColumnDefinition,
  accountColumnDefinition,
  multiplierColumnDefinition,
  recurrenceFrequency,
  annualCumulative,
  amountColumnDefinition,
  bookToTaxCodeDescriptionColumnDefinition,
} from '../columnDefinitions';

import {
  alignLeftCellStyle,
} from '@common/cellStyles';

export default [
  companyCodeColumnDefinition,
  { ...countryTaxTypeDescriptionColumnDefinition, headerName: 'Country Tax Type' },
  adjustmentTypeColumnDefinition,
  descriptionColumnDefinition,
  amountFromColumnDefinition,
  accountColumnDefinition,
  multiplierColumnDefinition,
  { ...recurrenceFrequency, ...alignLeftCellStyle },
  annualCumulative,
  amountColumnDefinition,
  bookToTaxCodeDescriptionColumnDefinition,
];
